import {
  Component,
  ElementRef,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  AcceptedByProjectAdminAllocationSheetsInput,
  AllocationSheetsServiceProxy,
  FileDto,
  FormDefinitionDto,
  FormsServiceProxy,
  GetSubmittedFormDataToExcelInput,
} from '@shared/service-proxies/service-proxies';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';

@Component({
  selector: 'allocationBulkDownloadModal',
  templateUrl: './allocation-bulk-download-modal.component.html',
  styleUrls: ['allocation-bulk-download-modal.component.less'],
})
export class AllocationBulkDownloadModalComponent
  extends AppComponentBase
  implements OnInit
{
  all = false;
  bsConfig = new BsDaterangepickerConfig();
  bsInlineRangeValue: Date[] = [];

  @ViewChild('modal', { static: true })
  modal: ModalDirective;

  @ViewChild('fileDownloader', { static: true })
  fileDownloader: ElementRef = null;

  projectId: string;
  selectedItem: any;

  listForms: FormDefinitionDto[] = [];
  constructor(
    injector: Injector,
    private _fileDownloadService: FileDownloadService,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy,
    private _formServiceProxy: FormsServiceProxy,
    private _projectService: ProjectService
  ) {
    super(injector);

    this.bsConfig.displayMonths = 1;
    this.bsConfig.containerClass = 'custom-datapicker';
  }
  async ngOnInit() {
    this._formServiceProxy
      .getFormDefinitions(false, 1000, 0, undefined)
      .subscribe((x) => {
        this.listForms = x.items;
      });
  }

  show(): void {
    this.modal.show();
  }

  close(): void {
    this.bsInlineRangeValue = [];

    this.modal.hide();
  }

  toogleAllState(): void {
    this.all = !this.all;
  }

  onDateValueChange(dates: Date[]): void {
    this.bsInlineRangeValue = dates;
  }

  download(): void {
    const body = new AcceptedByProjectAdminAllocationSheetsInput();
    body.all = this.all;
    body.startDate = moment(this.bsInlineRangeValue[0]).startOf('day');
    body.endDate = moment(this.bsInlineRangeValue[1]).endOf('day');
    if (this.selectedItem === this.l('AllocationActivity')) {
      this._allocationSheetsServiceProxy
        .acceptedByProjectAdminAllocationSheetsExportToExcel(body)
        .subscribe((response: FileDto) => {
          this._fileDownloadService.downloadTempFile(response);
          this.modal.hide();
        });
    } else {
      let formboy: GetSubmittedFormDataToExcelInput = {
        definitionId: this.selectedItem.id,
        startTime: body.startDate,
        endTime: body.endDate,
        init: undefined,
        toJSON: undefined,
      };
      this._formServiceProxy.submittedFormDataToExcel(formboy).subscribe((response: FileDto) => {
        this._fileDownloadService.downloadTempFile(response);
        this.modal.hide();
      });
    }
  }

  private startDownloading(attachment: string, name: string): void {
    this.fileDownloader.nativeElement.href = attachment;
    this.fileDownloader.nativeElement.download = name;
    this.fileDownloader.nativeElement.click();

    window.URL.revokeObjectURL(attachment);
  }
}
